import {POST, GET} from "@/services/gateway";

const list = () => {
  return GET('dropbox/user/backupsetings');
}

const updateAutoAdd = ({seatType, autoAdd}) => {
  return POST('dropbox/user/backupsetings', {
    seatType, autoAdd
  })
}


export {
  list,
  updateAutoAdd
}
